export const ATTACHMENTS_EN = {
    'nav.module.attachments': 'Attachments',
    'entity.attachments.subject': 'attachments',
    'attachments.subject_files.title': 'Attachments',
    'attachments.card.empty': 'No file is attached yet.',
    'attachments.col.file_name': 'File',
    'attachments.col.file_kind': 'Type',
    'attachments.col.category': 'Category',
    'attachments.col.file_size': 'Size',
    'attachments.col.created_by_name': 'Attached by',
    'attachments.col.created_at': 'When',
    'attachments.col.id': 'Id',
    'attachments.col.can_download': 'Can download',
    'attachments.col.can_withdraw': 'Can withdraw',
    'attachments.kind.pdf': 'PDF',
    'attachments.kind.image': 'Picture',
    'attachments.kind.audio': 'Recording',
    'attachments.kind.word': 'Word',
    'attachments.kind.sheet': 'Spreadsheet',
    'attachments.kind.slides': 'Slides',
    'attachments.kind.text': 'Text',
    'attachments.kind.other': 'Other',
    'attachments.action.attach': 'Attach a file',
    'attachments.action.download': 'Download',
    'attachments.action.withdraw': 'Withdraw',
    'attachments.field.file': 'File',
    'attachments.field.file.help': 'A PDF, a picture, a Word, Excel or PowerPoint file, or plain text. A name already attached becomes its next version.',
    'attachments.field.description': 'Description',
    'attachments.field.reason': 'Why',
    'attachments.field.reason.help': 'The file is hidden from the record and kept; it can be restored for 30 days.',
    'attachments.refusal.subject': 'This is not a record a file can be kept on.',
    'attachments.refusal.not_found': 'There is no such record, or it is not yours to read.',
    'attachments.refusal.unknown_entity': 'Files cannot be kept on this kind of record.',
    'attachments.refusal.access_unavailable': 'Who may read this record could not be checked just now. Nothing was changed; try again.',
    'attachments.refusal.file_required': 'Choose a file to attach.',
    'attachments.refusal.file_type': 'Attach a PDF, a picture, a Word, Excel or PowerPoint file, plain text or a voice recording.',
    'attachments.refusal.file_empty': 'The file is empty.',
    'attachments.refusal.file_too_large': 'The file is larger than {max_mb} MB.',
    'attachments.refusal.file_name_required': 'A file needs a name.',
    'attachments.refusal.name_taken': 'Another file on this record already has this name.',
    'attachments.refusal.stale': 'Somebody changed this file since you opened it. Reload and try again.',
    'attachments.refusal.withdrawn': 'This file was removed. Restore it first.',
    'attachments.refusal.restore_expired': 'A removed file can be restored for {days} days only.',
    'attachments.refusal.max_mb': 'The largest file is a whole number of MB from {min} to {max}.',
    'attachments.refusal.too_long': 'At most {max} characters.',
    'attachments.refusal.not_text': 'This must be text.',
    'attachments.refusal.media_missing': 'That file is not in this workspace.',
    'attachments.refusal.media_refused': 'The file store did not accept the file.',
    'attachments.refusal.media_forbidden': 'You may not upload or read files.',
    'attachments.refusal.media_unavailable': 'The file store did not answer. Nothing was saved.',
    'attachments.refusal.category_unknown': 'Choose one of the categories this record offers.',
    'attachments.refusal.category_unavailable': 'The categories of this record could not be read just now. Nothing was saved; try again.',
    'attachments.refusal.category_forbidden': 'You may not read this workspace\'s modules, so the category could not be checked.',
    'attachments.category.none': 'Uncategorised',
    'attachments.refusal.taken_at': 'Write when it was taken as a date and time with its zone.',
    'attachments.refusal.lat': 'The latitude is a number from {min} to {max}.',
    'attachments.refusal.lng': 'The longitude is a number from {min} to {max}.',
    'attachments.refusal.accuracy_m': 'The accuracy is a number of metres from {min} to {max}.',
    'attachments.refusal.position_pair': 'A position needs both its latitude and its longitude.',
    'attachments.refusal.accuracy_without_position': 'An accuracy belongs to a position; give the position too.',
    'attachments.refusal.visibility': 'Choose whether the file stays with the workspace or is shared on the portal.',
    'attachments.portal.files': 'Files',
    'attachments.visibility.staff': 'Workspace only',
    'attachments.visibility.portal': 'Shared on the portal',
    'attachments.uploaded_kind.member': 'The workspace',
    'attachments.uploaded_kind.portal': 'The portal',
    'change.field.file.subject_entity': 'Record type',
    'change.field.file.subject_id': 'Record',
    'change.field.file.media_id': 'Stored file',
    'change.field.file.file_name': 'Name',
    'change.field.file.file_type': 'Type',
    'change.field.file.file_size': 'Size',
    'change.field.file.description': 'Description',
    'change.field.file.category': 'Category',
    'change.field.file.taken_at': 'Taken',
    'change.field.file.lat': 'Latitude',
    'change.field.file.lng': 'Longitude',
    'change.field.file.accuracy_m': 'Position accuracy (m)',
    'change.field.file.visibility': 'Shared on the portal',
    'change.field.file.uploaded_kind': 'Attached from',
    'change.field.file.version_no': 'Version',
    'change.field.file.previous_id': 'Earlier version',
    'change.field.file.current': 'Current',
    'change.field.file.status': 'State',
    'change.field.file.withdrawn_at': 'Removed',
    'change.field.file.withdrawn_by': 'Removed by',
    'change.field.file.withdraw_reason': 'Why removed',
    'change.field.file.created_by': 'Attached by',
    'change.field.file.created_by_name': 'Attached by (name)',
    'change.field.settings.max_mb': 'Largest file (MB)',
    'change.field.settings.updated_by': 'Changed by',
};
export const ATTACHMENTS_AR = {
    'nav.module.attachments': 'المرفقات',
    'entity.attachments.subject': 'المرفقات',
    'attachments.subject_files.title': 'المرفقات',
    'attachments.card.empty': 'لا ملف مرفق بعد.',
    'attachments.col.file_name': 'الملف',
    'attachments.col.file_kind': 'النوع',
    'attachments.col.category': 'التصنيف',
    'attachments.col.file_size': 'الحجم',
    'attachments.col.created_by_name': 'أرفقه',
    'attachments.col.created_at': 'متى',
    'attachments.col.id': 'المعرّف',
    'attachments.col.can_download': 'يمكن تنزيله',
    'attachments.col.can_withdraw': 'يمكن سحبه',
    'attachments.kind.pdf': 'PDF',
    'attachments.kind.image': 'صورة',
    'attachments.kind.audio': 'تسجيل صوتي',
    'attachments.kind.word': 'Word',
    'attachments.kind.sheet': 'جدول',
    'attachments.kind.slides': 'عرض شرائح',
    'attachments.kind.text': 'نص',
    'attachments.kind.other': 'أخرى',
    'attachments.action.attach': 'أرفق ملفًّا',
    'attachments.action.download': 'تنزيل',
    'attachments.action.withdraw': 'سحب',
    'attachments.field.file': 'الملف',
    'attachments.field.file.help': 'ملف PDF أو صورة أو ملف Word أو Excel أو PowerPoint أو نص. الاسم المرفق من قبل يصبح نسخته التالية.',
    'attachments.field.description': 'الوصف',
    'attachments.field.reason': 'السبب',
    'attachments.field.reason.help': 'يُخفى الملف عن السجل ويُحفظ؛ ويمكن استعادته خلال 30 يومًا.',
    'attachments.refusal.subject': 'هذا ليس سجلًّا يمكن إرفاق ملف به.',
    'attachments.refusal.not_found': 'لا يوجد هذا السجل، أو ليس لك أن تطّلع عليه.',
    'attachments.refusal.unknown_entity': 'لا يمكن إرفاق ملفات بهذا النوع من السجلات.',
    'attachments.refusal.access_unavailable': 'تعذّر الآن التحقق ممن يحق له رؤية هذا السجل. لم يتغيّر شيء؛ حاول مرة أخرى.',
    'attachments.refusal.file_required': 'اختر ملفًّا لإرفاقه.',
    'attachments.refusal.file_type': 'أرفق ملف PDF أو صورة أو ملف Word أو Excel أو PowerPoint أو نصًّا عاديًّا أو تسجيلاً صوتياً.',
    'attachments.refusal.file_empty': 'الملف فارغ.',
    'attachments.refusal.file_too_large': 'حجم الملف أكبر من {max_mb} ميغابايت.',
    'attachments.refusal.file_name_required': 'الملف يحتاج إلى اسم.',
    'attachments.refusal.name_taken': 'يوجد ملف آخر على هذا السجل بالاسم نفسه.',
    'attachments.refusal.stale': 'غيّر أحدٌ هذا الملف بعد أن فتحته. أعد التحميل وحاول مرة أخرى.',
    'attachments.refusal.withdrawn': 'هذا الملف أُزيل. استعده أولًا.',
    'attachments.refusal.restore_expired': 'يمكن استعادة الملف المُزال خلال {days} يومًا فقط.',
    'attachments.refusal.max_mb': 'أكبر حجم للملف عدد صحيح من الميغابايت بين {min} و{max}.',
    'attachments.refusal.too_long': 'بحدّ أقصى {max} حرفًا.',
    'attachments.refusal.not_text': 'يجب أن يكون نصًّا.',
    'attachments.refusal.media_missing': 'هذا الملف ليس في مساحة العمل هذه.',
    'attachments.refusal.media_refused': 'لم يقبل مخزن الملفات هذا الملف.',
    'attachments.refusal.media_forbidden': 'ليس لك أن ترفع الملفات أو تقرأها.',
    'attachments.refusal.media_unavailable': 'لم يُجب مخزن الملفات. لم يُحفظ شيء.',
    'attachments.refusal.category_unknown': 'اختر تصنيفًا من التصنيفات التي يتيحها هذا السجل.',
    'attachments.refusal.category_unavailable': 'تعذّرت قراءة تصنيفات هذا السجل الآن. لم يُحفظ شيء؛ حاول مرة أخرى.',
    'attachments.refusal.category_forbidden': 'ليس لك أن تطّلع على وحدات مساحة العمل هذه، فتعذّر التحقق من التصنيف.',
    'attachments.category.none': 'بلا تصنيف',
    'attachments.refusal.taken_at': 'اكتب وقت الالتقاط تاريخًا ووقتًا مع منطقته الزمنية.',
    'attachments.refusal.lat': 'خط العرض رقم من {min} إلى {max}.',
    'attachments.refusal.lng': 'خط الطول رقم من {min} إلى {max}.',
    'attachments.refusal.accuracy_m': 'الدقة عدد من الأمتار من {min} إلى {max}.',
    'attachments.refusal.position_pair': 'الموقع يحتاج إلى خط العرض وخط الطول معًا.',
    'attachments.refusal.accuracy_without_position': 'الدقة تخصّ موقعًا؛ أدخل الموقع أيضًا.',
    'attachments.refusal.visibility': 'اختر هل يبقى الملف لمساحة العمل أم يُشارَك في البوابة.',
    'attachments.portal.files': 'الملفات',
    'attachments.visibility.staff': 'لمساحة العمل فقط',
    'attachments.visibility.portal': 'مُشارَك في البوابة',
    'attachments.uploaded_kind.member': 'مساحة العمل',
    'attachments.uploaded_kind.portal': 'البوابة',
    'change.field.file.subject_entity': 'نوع السجل',
    'change.field.file.subject_id': 'السجل',
    'change.field.file.media_id': 'الملف المخزَّن',
    'change.field.file.file_name': 'الاسم',
    'change.field.file.file_type': 'النوع',
    'change.field.file.file_size': 'الحجم',
    'change.field.file.description': 'الوصف',
    'change.field.file.category': 'التصنيف',
    'change.field.file.taken_at': 'وقت الالتقاط',
    'change.field.file.lat': 'خط العرض',
    'change.field.file.lng': 'خط الطول',
    'change.field.file.accuracy_m': 'دقة الموقع (م)',
    'change.field.file.visibility': 'المشاركة في البوابة',
    'change.field.file.uploaded_kind': 'أُرفق من',
    'change.field.file.version_no': 'النسخة',
    'change.field.file.previous_id': 'النسخة السابقة',
    'change.field.file.current': 'الحالية',
    'change.field.file.status': 'الحالة',
    'change.field.file.withdrawn_at': 'أُزيل في',
    'change.field.file.withdrawn_by': 'أزاله',
    'change.field.file.withdraw_reason': 'سبب الإزالة',
    'change.field.file.created_by': 'أرفقه',
    'change.field.file.created_by_name': 'اسم من أرفقه',
    'change.field.settings.max_mb': 'أكبر ملف (ميغابايت)',
    'change.field.settings.updated_by': 'غيّره',
};
//# sourceMappingURL=i18n-attachments.js.map